import { Link } from "react-router-dom";
import { Button } from "../components/Button";

export default function Contact() {
    return (
        <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-blue-50 to-amber-50 p-6 flex items-center justify-center">
            <div className="max-w-2xl w-full bg-white/80 backdrop-blur rounded-2xl shadow-xl p-8 space-y-6 text-center">
                <h1 className="text-3xl font-bold text-indigo-700">Contact</h1>

                <p className="text-gray-700 text-lg">
                    Ai întrebări sau dorești să colaborăm? Scrie-ne și îți răspundem cât mai repede.
                </p>

                <div className="bg-indigo-50 rounded-xl p-5 text-left space-y-2 text-sm text-gray-700">
                    <p>
                        <strong>Email:</strong> fundatie.socrate@gmail.com
                    </p>
                    <p>
                        <strong>Telefon:</strong> 004 0771 199 084
                    </p>
                    <p>
                        <strong>Whatsapp:</strong> 004 0771 199 084
                    </p>
                    <p>
                        <strong>Website:</strong> fundatiesocrate.ro
                    </p>
                    <p>
                        <strong>Adresă:</strong> str. Meţianu, nr. 1, Loc. Curtici, Jud. Arad, România
                    </p>
                </div>



                <Link to="/">
                    <Button variant="outline" className="w-full">
                        Înapoi la pagina principală
                    </Button>
                </Link>
            </div>
        </div>
    );
}
